import { CrudModel } from "./_crud";

export class NeedAppModel extends CrudModel {
	constructor() {
		super("app/need", [], []);
	}
}

export default new NeedAppModel();
